// extracted by mini-css-extract-plugin
export var burgerContainer = "styles-module--burgerContainer--1mI-h";
export var Burger = "styles-module--Burger--uNKuG";
export var line = "styles-module--line--1GeVR";
export var clicked = "styles-module--clicked--3-Uh9";
export var shorterLine = "styles-module--shorterLine--Q92Ow";
export var inactive = "styles-module--inactive--gLjtc";